import BaseService from './base.service';

class CommonService extends BaseService {
  
  async getCountries() {
    const response = await this.get('countries');
    return response.data;
  }
}

export default new CommonService();